import React from 'react';
import { CopySetRequest, DetailsFieldsSet, useDetailsFieldsSetsService } from 'nekst-api';
import { AfterSubmitFunc, FormTemplate, TextInput } from 'ui-builder';
import { ProjectTypeDropdown } from 'features/tasks-forms';
import useSettingsNavigator from '../../../settingsNavigator';

export default function CopySetForm(
  props: {
    detailsSet: DetailsFieldsSet,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const detailsSetService = useDetailsFieldsSetsService();

  const settingsNavigator = useSettingsNavigator();

  return (
    <FormTemplate<CopySetRequest, DetailsFieldsSet>
      submitFormFunc={(data) => {
        return detailsSetService.copySet(props.detailsSet.id, data);
      }}
      initialData={{
        name: props.detailsSet.name,
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          }
        },
        toProjectType: {
          type: 'string',
          constraints: {
            required: true,
          }
        }
      }}
      afterSubmitFunc={async (data) => {
        props.afterSubmitFunc?.(data);

        settingsNavigator.openDetailsSetPage(data.projectType, data.id);
      }}
      title={`Copy "${props.detailsSet.name}" set`}
    >
      <ProjectTypeDropdown source="toProjectType" label="Transaction Type" />
      <TextInput source="name" label="Name" />
    </FormTemplate>
  );
}
